import { render, staticRenderFns } from "./calendarDetails.vue?vue&type=template&id=5d082772&scoped=true"
import script from "./calendarDetails.vue?vue&type=script&lang=js"
export * from "./calendarDetails.vue?vue&type=script&lang=js"
import style0 from "./calendarDetails.vue?vue&type=style&index=0&id=5d082772&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d082772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d082772')) {
      api.createRecord('5d082772', component.options)
    } else {
      api.reload('5d082772', component.options)
    }
    module.hot.accept("./calendarDetails.vue?vue&type=template&id=5d082772&scoped=true", function () {
      api.rerender('5d082772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/calendar/components/calendarDetails.vue"
export default component.exports